// extracted by mini-css-extract-plugin
export default {"container":"FixedFooter-module_container_cbf3b4"};